<template>
  <v-card>
    <v-card-title class="text-h7">
      <v-icon color="blue darken-2" size="32" class="mr-3"
        >mdi-warehouse</v-icon
      >
      {{ sucursalLocal.sucursal.nombre }}
    </v-card-title>
    <v-card-text>
      <v-row align="center">
        <v-col cols="12" md="8">
          <GenericAttributeInput
            attributeName="precio_venta"
            label="Precio de venta"
            type="number"
            :value="sucursalLocal.precio_venta"
            :rules="`required|decimal:2`"
            :outlined="true"
            :disabled="false"
            @update-attribute="handleAttributeUpdateBase"
          />
        </v-col>

        <v-col cols="12" md="4" class="text-center">
          <v-btn
            outlined
            color="primary"
            :disabled="!hayCambios"
            @click="actualizarPrecioSucursal"
          >
            Actualizar precio
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import GenericAttributeInput from "@/components/util/GenericAttributeInput.vue";
import ProductosAPI from "@/api/productos";


export default {
  components: {
    GenericAttributeInput,
  },
  props: {
    productoConSucursal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sucursalLocal: {}, // copia local
      precioVentaOriginal: null, // valor original para detectar cambios
    };
  },
  computed: {
    hayCambios() {
      return (
        Number(this.sucursalLocal.precio_venta) !==
        Number(this.precioVentaOriginal)
      );
    },
  },
  created() {
    // Crear copia local de la prop

    this.sucursalLocal = JSON.parse(JSON.stringify(this.productoConSucursal));
    console.log(this.sucursalLocal);
    this.precioVentaOriginal = this.sucursalLocal.precio_venta;
  },
  methods: {
    handleAttributeUpdateBase({ name, value }) {
      this.$set(this.sucursalLocal, name, value);
    },

    async actualizarPrecioSucursal() {
      try {
        console.log("Hola");
        
        const response = await ProductosAPI.actualizarPrecioSucursal(
          this.sucursalLocal.id,
          this.sucursalLocal.precio_venta
        );

        this.$emit("actualizacionExitosa", response.data);

        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "success",
          text: "Precio actualizado exitosamente",
          icon: "mdi-check",
          timeout: 3000,
        });
      } catch (error) {
        console.error(error);
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "error",
          text: `Error al actualizar precio: ${
            error.response?.data?.error || "Error desconocido"
          }`,
          icon: "mdi-alert-circle",
          timeout: 3000,
        });
      }
    },
  },
};
</script>
